import React from 'react';
import {
  Block,
  MenuItem,
  MenuDropdown,
  MenuDropdownItem,
  Icon
} from 'framework7-react';
import { dict } from '../translate/dictionary';
import II18 from '../translate/II18';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedLang } from '../../redux/actions/rootAction';

export default function ChangeLang() {
  const dispatch = useDispatch();
  const selectedLang = useSelector(state => state.selectedLang);
  const onChangeLang = lang => {
    dispatch(setSelectedLang(lang));
  };

  return (
    <Block
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <span className={'langInfo flag-' + II18.get('lang_short')} />

      <MenuItem text={dict[selectedLang].lang} dropdown className={'langMenu'}>
        <MenuDropdown center>
          {Object.keys(dict).map(lang => (
            <MenuDropdownItem
              iconMaterial={selectedLang === lang ? 'done' : ''}
              onClick={() => onChangeLang(lang)}
              key={lang}
              id={`lang-${lang}`}
              href="#"
              text={dict[lang].lang}
            >
              {selectedLang === lang && (
                <Icon className="margin-left" material="done" />
              )}
            </MenuDropdownItem>
          ))}
        </MenuDropdown>
      </MenuItem>
    </Block>
  );
}

ChangeLang.propTypes = {};
